import { createSlice } from "@reduxjs/toolkit";
import { sseModule } from "../../../store";
import {
  STORE_SLICES,
  REQUEST_STATUSES,
  INITIAL_ERROR_STATE,
  DEFAULT_ERROR_TEXT,
} from "../../../packages/constants";
import { auth, resetError, resetStatus, resetStore } from "../actions";
import { requestModule } from "../request-module";
import { AUTH_ENDPOINT_NAMES } from "../types";
import { initialState } from "./initial-state";

const authSlice = createSlice({
  name: STORE_SLICES.AUTH,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
    builder.addCase(resetStatus, (state, action) => {
      const { endpoint } = action.payload;

      state.requestStatuses[endpoint] = REQUEST_STATUSES.PENDING;
    });
    builder.addCase(resetError, (state, action) => {
      const { endpoint } = action.payload;

      state.requestStatuses[endpoint] = REQUEST_STATUSES.PENDING;
      state.errorMessages[endpoint] = INITIAL_ERROR_STATE;
    });

    builder.addCase(auth.pending, (state) => {
      state.requestStatuses[AUTH_ENDPOINT_NAMES.AUTH] =
        REQUEST_STATUSES.LOADING;

      requestModule.turnOnRefreshing();
    });
    builder.addCase(auth.fulfilled, (state, action) => {
      const { access, user } = action.payload;
      const { token, expired } = access;

      requestModule.turnOffRefreshing(token, expired);

      state.requestStatuses[AUTH_ENDPOINT_NAMES.AUTH] =
        REQUEST_STATUSES.SUCCESS;
      state.user = user;
      state.access = access;

      sseModule.setData(user.id, token);
    });
    builder.addCase(auth.rejected, (state, action) => {
      const { message = DEFAULT_ERROR_TEXT } = action.error;
      const [type, status] = message.split("/");

      state.requestStatuses[AUTH_ENDPOINT_NAMES.AUTH] = REQUEST_STATUSES.ERROR;
      state.errorMessages[AUTH_ENDPOINT_NAMES.AUTH] = { type, status };

      // requestModule.turnOffRefreshing("", NaN);
    });
  },
});

export const authReducer = authSlice.reducer;
